import * as types from '../mutation-types'
import * as constants from '../../mixins/constants'
import {
  // getLastestOrder,
  getListServices,
  getOrderDetail,
  getOrderListByToken,
  getListTicket,
  getTicketComment,
  serviceDetail,
  commentTicket,
  rateSatisfaction
} from '@/store/api/order'

const state = {
  lastest_order: {},
  loading_order: true,
  loading_list_ticket: true,
  loading_ticket_comment: true,
  dataLoaded: false,
  order_list_help_center: [],
  list_ticket_help_center: [],
  detail_comment: {}
}

// getters
const getters = {
  lastestOrder: (state) => state.lastest_order,
  loadingLastestOrder: (state) => state.loading_order,
  loadedDataOrder: (state) => state.dataLoaded,
  orderListHelpCenter: (state) => state.order_list_help_center,
  listTicketHelpCenter: (state) => state.list_ticket_help_center,
  detailComment: (state) => state.detail_comment,
  loadingListTicket: (state) => state.loading_list_ticket,
  loadingTicketComment: (state) => state.loading_ticket_comment
}

// actions
const actions = {
  setLastestOrder({ commit }, order) {
    commit(types.SET_LASTEST_ORDER, order)
  },
  setOrderList({ commit }, data) {
    commit(types.SET_ORDER_LIST_HELP_CENTER, data)
  },

  getListServices({ dispatch }, city_id) {
    return new Promise((resolve, reject) => {
      let param = {
        city_id: city_id
      }

      getListServices(param)
        .then((response) => {
          if (response && response.status === 200) {
            dispatch('setServiceTypes', response.data)
            resolve(response)
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getOrderDetail({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      let params = {
        token: data.token,
        order_id: data.order_id
      }
      state.loading_order = true

      getOrderDetail(params)
        .then((response) => {
          if (response) {
            if (
              response.status === constants.ORDER_STATUS.COMPLETED ||
              response.status === constants.ORDER_STATUS.CANCELLED
            ) {
              commit(types.SET_LASTEST_ORDER, response)
              // console.log("response", response)
            } else {
              commit(types.SET_LASTEST_ORDER, {})
            }
            resolve(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
        .finally(() => {
          state.loading_order = false
        })
    })
  },

  getOrderListByToken({ commit }, token) {
    return new Promise((resolve, reject) => {
      let params = {
        token: token,
        total: true,
        to_time: parseInt(new Date() / 1000),
        from_time: parseInt(new Date() / 1000 - 72 * 3600),
        status: 'COMPLETED,CANCELLED,IN PROCESS',
        count: 5,
        offset: 0
      }
      state.dataLoaded = false
      getOrderListByToken(params)
        .then((response) => {
          if (response && response.status === 200 && response.data.orders.length !== 0) {
            // state.dataLoaded = true
            state.loading_order = false
            commit(types.SET_ORDER_LIST_HELP_CENTER, response.data.orders)
            commit(types.SET_LASTEST_ORDER, response.data.orders[0])

            resolve(response.data.orders)
          } else {
            // state.loading_order = false
            commit(types.SET_ORDER_LIST_HELP_CENTER, response.data.orders)
          }
        })
        .catch((err) => {
          reject(err)
        })
        .finally(() => {
          state.loading_order = false
          state.dataLoaded = true
        })
    })
  },

  getListTicket({ commit, state }, token) {
    state.loading_list_ticket = true

    return new Promise((resolve, reject) => {
      let params = {
        token: token,
        page: 1
      }

      getListTicket(params)
        .then((response) => {
          let result = []
          if (response && response.tickets) {
            response.tickets.forEach((ticket) => {
              result.push(ticket)
            })
            state.loading_list_ticket = false
            result.reverse()
            commit(types.SET_LIST_TICKET_HELP_CENTER, result)
            resolve(result)
          } else {
            state.loading_list_ticket = false
            resolve(response)
          }
        })
        .catch((error) => {
          state.loading_list_ticket = false
          reject(error)
        })
    })
  },

  getTicketComment({ commit, state }, data) {
    state.loading_ticket_comment = true
    return new Promise((resolve, reject) => {
      let params = {
        ticket_id: data.ticket_id,
        token: data.token
      }

      getTicketComment(params)
        .then((response) => {
          if (response && response.data) {
            state.loading_ticket_comment = false
            commit(types.SET_TICKET_COMMENT, response.data)
            resolve(response.data)
          }
        })
        .catch((error) => {
          state.loading_ticket_comment = false
          reject(error)
        })
    })
  },

  getTicketCommentSilent({ commit }, data) {
    return new Promise((resolve, reject) => {
      let params = {
        ticket_id: data.ticket_id,
        token: data.token
      }

      getTicketComment(params)
        .then((response) => {
          if (response && response.data) {
            commit(types.SET_TICKET_COMMENT, response.data)
            resolve(response.data)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  /* eslint-disable */
  getServiceDetail({ commit }, service_id) {
    return new Promise((resolve, reject) => {
      let params = {
        service_id: service_id
      }
      serviceDetail(params)
        .then((response) => {
          if (response && response.status === 200 && response.data) {
            resolve(response.data)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  updateCommentTicket({ commit }, data) {
    return new Promise((resolve, reject) => {
      let params = {
        token: data.token,
        ticket_id: data.ticket_id,
        author_id: data.author_id,
        comment: data.comment
      }

      commentTicket(params)
        .then((response) => {
          if (response) {
            resolve(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  rateTicket({ commit }, data) {
    return new Promise((resolve, reject) => {
      let params = {
        token: data.token,
        ticket_id: data.ticket_id,
        score: data.score,
        comment: data.comment,
        reason_code: data.reason_code
      }

      rateSatisfaction(params)
        .then((response) => {
          if (response) {
            resolve(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  /* eslint-enable */

  resetTicket({ commit }) {
    commit(types.SET_LIST_TICKET_HELP_CENTER, [])
    commit(types.SET_TICKET_COMMENT, {})
  },

  setLoadingLastestOrder({ commit }, value) {
    commit(types.SET_LOADING_LASTEST_ORDER, value)
  },

  setLoadingTicketComment({ commit }, value) {
    commit(types.SET_LOADING_TICKET_COMMENT, value)
  }
}

// mutations
const mutations = {
  [types.SET_LASTEST_ORDER](state, data) {
    state.lastest_order = data
  },

  [types.SET_ORDER_LIST_HELP_CENTER](state, data) {
    state.order_list_help_center = [...data]
  },

  [types.SET_LIST_TICKET_HELP_CENTER](state, data) {
    state.list_ticket_help_center = [...data]
  },

  [types.SET_TICKET_COMMENT](state, data) {
    state.detail_comment = data
  },

  [types.SET_LOADING_LASTEST_ORDER](state, value) {
    state.loading_order = value
  },

  [types.SET_LOADING_TICKET_COMMENT](state, value) {
    state.loading_ticket_comment = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
